import ax from '@utils/axios'
import { useUserStore } from '@stores/users'

function generateQueryParams(queryParams = {}) {
  // TODO: move into a helper since it's used in a few places
  // turns key value pairs into a query string to append to a URL
  const queryString = Object.entries(queryParams)
    .map(([key, value]) => {
      return `${encodeURIComponent(key)}=${value}`
    })
    .join('&')
  return queryString
}

async function fetchLeadMetrics({dateRange, partnerIds, tagIds}) {
  const userStore = useUserStore()
  if (partnerIds?.length) {
    this.partnerCampaignCategories = []
  }

  try {
    this.showLeadMetricsLoadingIndicator = true
    let queryParams = ''
    if (userStore.user.role === 'vendor') {
      if (tagIds?.length) {
        queryParams = `tag_ids=${tagIds.join(',')}`
      } 
      if (partnerIds?.length) {
        queryParams += `&partner_ids=${partnerIds}`
      } 
    } else {
      queryParams += `partner_ids=${userStore.partnerId}`
    }

    // if startDate and endDate are set, append them to queryParams
    if (dateRange) {
      // Parse dateRange.from (format YYY/MM/DD) and convert it to a date
      let fromDate = new Date(dateRange[0])
      let toDate = new Date(dateRange[1])

      fromDate.setUTCHours(0,0,0,0)
      toDate.setUTCHours(0,0,0,0)

      let from = fromDate.toISOString()
      let to = toDate.toISOString()

      queryParams += `&start_date=${from}&end_date=${to}`
    }

    const { data } = await ax.get(`/v2/reports/lead-metrics?${queryParams}`)

    const formattedData = []

    for (const item in data.stats_by_partner) {
      formattedData.push(data.stats_by_partner[item])
    }

    if (data.stats_by_partner) {
      for (let partnerId in data.stats_by_partner) {
        if (!this.partnerCategories.find((partner) => partner.value === partnerId)) {
          this.partnerCategories.push({ label: data.stats_by_partner[partnerId].partner_name, value: partnerId })
        }
      }
    }

    // sort partnerCategories by label
    this.partnerCategories.sort((a, b) => {
      if (a.label < b.label) {
        return -1
      }
      if (a.label > b.label) {
        return 1
      }
      return 0
    })

    this.leadMetricReport = formattedData
    this.leadMetricsTotals = data.totals
  } catch (error) {
    console.error('There was a problem fetching reports', error)
  } finally {
    this.showLeadMetricsLoadingIndicator = false
  }
}

async function fetchLeadMetricsChartData({dateRange, partnerIds, leadMetric, tagIds}) {
  this.selectedLeadMetric = leadMetric

  try {
    this.showLeadMetricsLoadingIndicator = true
    let queryParams = {}
    if (tagIds?.length) {
      queryParams.tag_ids = tagIds
    }

    if (partnerIds?.length) {
      queryParams.partner_ids = partnerIds
    }
    
    if (leadMetric) {
      queryParams.lead_metric = leadMetric.value
    }

    // if startDate and endDate are set, append them to queryParams
    if (dateRange) {
      // Parse dateRange.from (format YYY/MM/DD) and convert it to a date
      const fromDate = new Date(dateRange[0])
      const toDate = new Date(dateRange[1])

      let from = fromDate.toISOString()
      let to = toDate.toISOString()

      queryParams.start_date = from
      queryParams.end_date = to
    }
    const queryString = (Object.keys(queryParams).length > 0) ? `?${generateQueryParams(queryParams)}` : ''

    const reportsPath = `/v2/reports/lead-metrics/lead-metrics-charts${queryString}`
    const { data } = await ax.get(reportsPath)
    this.leadMetricsChartData = data.result
  } catch(error) {
    console.error('There was a problem fetching chart metrics', error)
  }
  finally {
    this.showLeadMetricsLoadingIndicator = false
  }
}

export default {
  fetchLeadMetrics,
  fetchLeadMetricsChartData,
}
